import React, { useEffect, useState, useRef } from "react";
import { any } from "prop-types";
import Carousel from "react-multi-carousel";

import "../carousel/carousel.m.css";
import "./carousel-partial.m.css";
import ArrowLeftIcon from "../icons/left-arrow-icon";
import ArrowRightIcon from "../icons/arrow-right";

const PartialCarousel = ({ children, length = 0, showBullets = true, showArrows = true }) => {
  if (!children) {
    return null;
  }

  const totalItems = length - 2;

  const [isMobile, setMobile] = useState(false);
  const carouselRef = useRef(null);

  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    if (window && window.innerWidth < 767) {
      setMobile(true);
    } else {
      setMobile(false);
    }
  }, []);

  useEffect(() => {
    if (carouselRef.current) {
      carouselRef.current.goToSlide(0);
    }
  }, [children]);

  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 768 },
      items: 3
      // paritialVisibilityGutter: 50
    },
    mobile: {
      breakpoint: { max: 767, min: 0 },
      items: 1
      // paritialVisibilityGutter: 80
    }
  };

  const handlePrevious = () => {
    if (carouselRef.current) {
      carouselRef.current.previous();
    }
  };

  const handleNext = () => {
    if (carouselRef.current) {
      carouselRef.current.next();
    }
  };

  const handleGoToSlide = (slideIndex) => {
    if (carouselRef.current) {
      carouselRef.current.goToSlide(slideIndex);
    }
  };

  const handleSlideChange = (previousSlide, state) => {
    setCurrentSlide(previousSlide);
    return true;
  };

  const renderGlideArrows = () => {
    return (
      <div className="glide__arrows" styleName="arrow-wrapper">
        <div
          onClick={handlePrevious}
          styleName={currentSlide === 0 ? "arrow-disabled arrow-icon-wrapper" : "arrow-icon-wrapper"}
        >
          <ArrowLeftIcon />
        </div>
        {showBullets && totalItems > 1 && renderBullets()}
        <div
          onClick={currentSlide < totalItems - 1 ? handleNext : null}
          styleName={currentSlide >= totalItems - 1 ? "arrow-disabled arrow-icon-wrapper" : "arrow-icon-wrapper"}
        >
          <ArrowRightIcon />
        </div>
      </div>
    );
  };

  const renderBullets = () => {
    return (
      <div styleName="indicators" className="indicators">
        {Array(totalItems)
          .fill(1)
          .map((item, index) => (
            <div
              key={index}
              styleName={`indicator-button ${currentSlide === index ? "active" : ""}`}
              onClick={() => {
                handleGoToSlide(index);
              }}
            />
          ))}
      </div>
    );
  };

  return (
    <div className="partial-carousel-wrapper" styleName="partial-carousel-wrapper">
      <Carousel
        arrows={false}
        partialVisible={!isMobile ? length > 3 : true}
        responsive={responsive}
        showDots={false}
        sliderClass="carousal-slider-track"
        containerClass="carousal-slider-container"
        itemClass="carousal-item-class"
        ref={carouselRef}
        beforeChange={handleSlideChange}
      >
        {children}
      </Carousel>
      {!isMobile && <div className="arrow-with-bullets">{showArrows && totalItems > 1 && renderGlideArrows()}</div>}
    </div>
  );
};

PartialCarousel.propTypes = {
  children: any
};

export default PartialCarousel;
